import { render } from "./AdminAuthModal.vue?vue&type=template&id=406a7137&scoped=true"
import script from "./AdminAuthModal.vue?vue&type=script&lang=js"
export * from "./AdminAuthModal.vue?vue&type=script&lang=js"

import "./AdminAuthModal.vue?vue&type=style&index=0&id=406a7137&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406a7137"]])

export default __exports__